module.exports = __webpack_public_path__ + "img/brand_1.6f10d5c9.png";